gsap.registerPlugin(ScrollTrigger);

    const wrapper = document.querySelector(".collection-list");
    const image = wrapper.querySelector(".upper_right.bell");

    gsap.from(image, {
        y: -300,
        duration: 1.5,
        ease: "in-out",

        scrollTrigger: {
            trigger: wrapper,
            start: "top 80%",
            markers: false
        }
    });

